import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const actions = createActions(
  {
    TELEPHONY_SET_LABEL: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_GET_ALL_NUMBERS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_GET_NUMBERS_BY_QUERY: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_RELEASE_NUMBER: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_UPDATE_NUMBER: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_BUY_NUMBER: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_BUY_GROUP: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_VERIFY_EXTERNAL_CALLER_ID: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_SEARCH_NUMBERS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_SEARCH_NUMBERS_BY_NUM_TYPE: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_CHANGE_COUNTRY_CODE: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    TELEPHONY_BUY_GROUP_NUMBER_DELIVERED: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'TELEPHONY_SHOW_EDIT_NUMBER_MODAL',
  'TELEPHONY_HIDE_EDIT_NUMBER_MODAL',

  'TELEPHONY_SET_LABEL_SUCCEEDED',
  'TELEPHONY_SET_LABEL_FAILED',

  'TELEPHONY_GET_ALL_NUMBERS_SUCCEEDED',
  'TELEPHONY_GET_ALL_NUMBERS_FAILED',

  'TELEPHONY_GET_NUMBERS_BY_QUERY_SUCCEEDED',
  'TELEPHONY_GET_NUMBERS_BY_QUERY_FAILED',

  'TELEPHONY_RELEASE_NUMBER_SUCCEEDED',
  'TELEPHONY_RELEASE_NUMBER_FAILED',

  'TELEPHONY_SHOW_RELEASE_NUMBER_MODAL',
  'TELEPHONY_HIDE_RELEASE_NUMBER_MODAL',

  'TELEPHONY_UPDATE_NUMBER_SUCCEEDED',
  'TELEPHONY_UPDATE_NUMBER_FAILED',

  'TELEPHONY_BUY_NUMBER_SUCCEEDED',
  'TELEPHONY_BUY_NUMBER_FAILED',

  'TELEPHONY_BUY_GROUP_SUCCEEDED',
  'TELEPHONY_BUY_GROUP_FAILED',

  'TELEPHONY_SHOW_BUY_NUMBER_MODAL',
  'TELEPHONY_HIDE_BUY_NUMBER_MODAL',

  'TELEPHONY_SHOW_EXTERNAL_CALLER_ID_MODAL',
  'TELEPHONY_HIDE_EXTERNAL_CALLER_ID_MODAL',

  'TELEPHONY_VERIFY_EXTERNAL_CALLER_ID_SUCCEEDED',
  'TELEPHONY_VERIFY_EXTERNAL_CALLER_ID_FAILED',

  'TELEPHONY_SHOW_SEARCH_NUMBER_MODAL',
  'TELEPHONY_HIDE_SEARCH_NUMBER_MODAL',

  'TELEPHONY_SEARCH_NUMBERS_SUCCEEDED',
  'TELEPHONY_SEARCH_NUMBERS_FAILED',

  'TELEPHONY_SEARCH_NUMBERS_BY_NUM_TYPE_SUCCEEDED',
  'TELEPHONY_SEARCH_NUMBERS_BY_NUM_TYPE_FAILED',
);
